class CartRemoveButton extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', (event) => {
      event.preventDefault()
      const cartItems =
        this.closest('cart-items') || this.closest('cart-drawer-items')
      cartItems.updateQuantity(this.dataset.index, 0, event)
    })
  }
}

customElements.define('cart-remove-button', CartRemoveButton)

class CartItems extends HTMLElement {
  constructor() {
    super()
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') ||
      document.getElementById('CartDrawer-LineItemStatus')

    const debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, ON_CHANGE_DEBOUNCE_TIMER)

    this.addEventListener('change', debouncedOnChange.bind(this))
  }

  cartUpdateUnsubscriber = undefined

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === 'cart-items') {
          return
        }
        console.log('Cart update triggered by:', event.source, 'with cart data:', event.cartData);
        return this.onCartUpdate()
      }
    )
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber()
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`)
    input.value = input.getAttribute('value')
    this.isEnterPressed = false
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message)
    event.target.reportValidity()
    this.resetQuantityInput(index)
    event.target.select()
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value)
    const index = event.target.dataset.index
    let message = ''

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        '[min]',
        event.target.dataset.min
      )
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        '[max]',
        event.target.max
      )
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        '[step]',
        event.target.step
      )
    }

    if (message) {
      this.setValidity(event, index, message)
    } else {
      event.target.setCustomValidity('')
      event.target.reportValidity()
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      )
    }
  }

  onChange(event) {
    this.validateQuantity(event)
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          )
          const selectors = ['cart-drawer-items', '.cart-drawer__footer']
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector)
            const sourceElement = html.querySelector(selector)
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement)
            }
          }
        })
        .catch((e) => {
          console.error(e)
        })
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            'text/html'
          )
          const sourceQty = html.querySelector('cart-items')
          this.innerHTML = sourceQty.innerHTML
        })
        .catch((e) => {
          console.error(e)
        })
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ]
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line)

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })
    const eventTarget =
      event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change'

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)

        CartPerformance.measure(
          `${eventTarget}:paint-updated-sections"`,
          () => {
            const quantityElement =
              document.getElementById(`Quantity-${line}`) ||
              document.getElementById(`Drawer-quantity-${line}`)
            const items = document.querySelectorAll('.cart-item')

            if (parsedState.errors) {
              quantityElement.value = quantityElement.getAttribute('value')
              this.updateLiveRegions(line, parsedState.errors)
              return
            }

            this.classList.toggle('is-empty', parsedState.item_count === 0)
            const cartDrawerWrapper = document.querySelector('cart-drawer')
            const cartFooter = document.getElementById('main-cart-footer')

            if (cartFooter)
              cartFooter.classList.toggle(
                'is-empty',
                parsedState.item_count === 0
              )
            if (cartDrawerWrapper)
              cartDrawerWrapper.classList.toggle(
                'is-empty',
                parsedState.item_count === 0
              )

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id)
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              )
            })
            const updatedValue = parsedState.items[line - 1]
              ? parsedState.items[line - 1].quantity
              : undefined
            let message = ''
            if (
              items.length === parsedState.items.length &&
              updatedValue !== parseInt(quantityElement.value)
            ) {
              if (typeof updatedValue === 'undefined') {
                message = window.cartStrings.error
              } else {
                message = window.cartStrings.quantityError.replace(
                  '[quantity]',
                  updatedValue
                )
              }
            }
            this.updateLiveRegions(line, message)

            const lineItem =
              document.getElementById(`CartItem-${line}`) ||
              document.getElementById(`CartDrawer-Item-${line}`)
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
              cartDrawerWrapper
                ? trapFocus(
                    cartDrawerWrapper,
                    lineItem.querySelector(`[name="${name}"]`)
                  )
                : lineItem.querySelector(`[name="${name}"]`).focus()
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
              trapFocus(
                cartDrawerWrapper.querySelector('.drawer__inner-empty'),
                cartDrawerWrapper.querySelector('a')
              )
            } else if (
              document.querySelector('.cart-item') &&
              cartDrawerWrapper
            ) {
              trapFocus(
                cartDrawerWrapper,
                document.querySelector('.cart-item__name')
              )
            }
          }
        )

        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event)

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-items',
          cartData: parsedState,
          variantId: variantId,
        })
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) =>
          overlay.classList.add('hidden')
        )
        const errors =
          document.getElementById('cart-errors') ||
          document.getElementById('CartDrawer-CartErrors')
        errors.textContent = window.cartStrings.error
      })
      .finally(() => {
        this.disableLoading(line)
      })
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`)
    if (lineItemError)
      lineItemError.querySelector('.cart-item__error-text').textContent =
        message

    this.lineItemStatusElement.setAttribute('aria-hidden', true)

    const cartStatus =
      document.getElementById('cart-live-region-text') ||
      document.getElementById('CartDrawer-LiveRegionText')
    cartStatus.setAttribute('aria-hidden', false)

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true)
    }, 1000)
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.add('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    )
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    )

    ;[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove('hidden')
    )

    document.activeElement.blur()
    this.lineItemStatusElement.setAttribute('aria-hidden', false)
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById('main-cart-items') ||
      document.getElementById('CartDrawer-CartItems')
    mainCartItems.classList.remove('cart__items--disabled')

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    )
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    )

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'))
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'))
  }
}

customElements.define('cart-items', CartItems)

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super()

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value })
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            }).then(() =>
              CartPerformance.measureFromEvent('note-update:user-action', event)
            )
          }, ON_CHANGE_DEBOUNCE_TIMER)
        )
      }
    }
  )
}

document.body.addEventListener('click', async e => {
  let btn = e.target.closest('.remove-btn[data-bundle-id], .remove-btn[data-bundle-separator]');
  if (!btn) return;

  // Find the specific bundle wrapper to add loading state
  const bundleSeparator = btn.getAttribute('data-bundle-separator');
  const bundleId = btn.getAttribute('data-bundle-id');
  let targetBundleWrapper = null;

  if (bundleSeparator) {
    targetBundleWrapper = document.querySelector(`.cart-drawer-bundle-wrapper:has([data-bundle-separator="${bundleSeparator}"])`);
  } else if (bundleId) {
    targetBundleWrapper = document.querySelector(`.cart-drawer-bundle-wrapper:has([data-bundle-id="${bundleId}"])`);
  }

  // Add loading state to the specific bundle wrapper
  if (targetBundleWrapper) {
    targetBundleWrapper.classList.add('loading');
    // Show the loading spinner for this specific bundle
    const loadingSpinner = targetBundleWrapper.querySelector('.loading__spinner');
    if (loadingSpinner) {
      loadingSpinner.classList.remove('hidden');
    }
  }

  try {
    // Fetch current cart data
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Find bundle items to remove
    const bundleItemsToRemove = [];
    cart.items.forEach((item, index) => {
      let shouldRemove = false;

      // More robust bundle item detection
      const isBundleItem = item.properties?._bundle_item === 'true' ||
                          item.properties?._bundle_item === true ||
                          item.properties?.bundle_item === 'true' ||
                          item.properties?.bundle_item === true;

      if (bundleSeparator && isBundleItem) {
        // Remove items by bundle separator
        const itemBundleSeparator = item.properties?._bundle_separator ||
                                   item.properties?.bundle_separator;
        shouldRemove = itemBundleSeparator === bundleSeparator;
      } else if (bundleId && isBundleItem) {
        // Remove items by bundle ID
        const itemBundleId = item.properties?._bundle_id ||
                            item.properties?.bundle_id;
        shouldRemove = itemBundleId === bundleId;
      }

      if (shouldRemove) {
        bundleItemsToRemove.push({ item, index: index + 1 }); // Shopify uses 1-based indexing
      }
    });

    // Only proceed if we found items to remove
    if (bundleItemsToRemove.length === 0) {
      console.warn('No bundle items found to remove');
      return;
    }

    // Get cart context element
    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (!cartItems) {
      console.error('No cart-items or cart-drawer-items found');
      return;
    }

    // Build updates object using item keys (correct format for cart_update_url)
    const updates = {};
    bundleItemsToRemove.forEach(({ item }) => {
      updates[item.key] = 0; // Set quantity to 0 to remove using item key
    });

    // Update cart with bundle removal using cart_update_url (for bulk updates)
    const body = JSON.stringify({
      updates,
      sections: cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    const updateResponse = await fetch(`${routes.cart_update_url}`, {
      ...fetchConfig(),
      ...{ body }
    });

    if (!updateResponse.ok) {
      throw new Error(`Cart update failed: ${updateResponse.status}`);
    }

    const cartData = await updateResponse.json();
    console.log('Bundle removal successful, cart data:', cartData);

    // Use the same approach as wishlist functionality - fetch fresh sections from server
    const cartDrawer = document.querySelector('cart-drawer');
    const cartItemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        console.log('Fetching fresh cart sections from server');
        const sectionsParam = cartDrawer.getSectionsToRender().map(s => s.id).join(',');
        const cartState = await fetch(`/?sections=${sectionsParam}`)
          .then(res => res.json());

        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ sections: cartState, ...cartData });

          // Handle empty state properly
          if (cartData.item_count > 0) {
            cartDrawer.classList.remove('is-empty');
            const drawerItems = cartDrawer.querySelector('cart-drawer-items');
            if (drawerItems) drawerItems.classList.remove('is-empty');
            const innerEmpty = cartDrawer.querySelector('.drawer__inner-empty');
            if (innerEmpty) innerEmpty.style.display = 'none';
          } else {
            cartDrawer.classList.add('is-empty');
            const drawerItems = cartDrawer.querySelector('cart-drawer-items');
            if (drawerItems) drawerItems.classList.add('is-empty');
          }

          console.log('Cart drawer updated with fresh sections');
        }
      } catch (err) {
        console.error('Error updating cart drawer:', err);
      }
    }

    // Also update cart icon bubble if it exists
    try {
      const cartIconBubbleResponse = await fetch('/?sections=cart-icon-bubble');
      if (cartIconBubbleResponse.ok) {
        const cartIconBubbleText = await cartIconBubbleResponse.text();
        const cartIconBubbleDoc = new DOMParser().parseFromString(cartIconBubbleText, 'text/html');
        const cartIconBubbleSection = cartIconBubbleDoc.getElementById('shopify-section-cart-icon-bubble');

        if (cartIconBubbleSection) {
          const cartIconBubbleHtml = cartIconBubbleSection.innerHTML;
          const cartIconBubble = document.getElementById('cart-icon-bubble');
          if (cartIconBubble) {
            cartIconBubble.innerHTML = cartIconBubbleHtml;
            console.log('Cart icon bubble updated');
          }
        }
      }
    } catch (err) {
      console.error('Error updating cart icon bubble:', err);
    }

    // Trigger cart update event
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'cart-items',
      cartData: cartData
    });

  } catch (error) {
    console.error('Error removing bundle:', error);

    // Remove loading state on error
    if (targetBundleWrapper) {
      targetBundleWrapper.classList.remove('loading');
      const loadingSpinner = targetBundleWrapper.querySelector('.loading__spinner');
      if (loadingSpinner) {
        loadingSpinner.classList.add('hidden');
      }
    }

    alert('There was a problem removing the bundle from your cart.');
  }
});
